import { render, staticRenderFns } from "./ClientZoneUserVenueAuthorizations.vue?vue&type=template&id=c11da638&scoped=true&"
import script from "./ClientZoneUserVenueAuthorizations.vue?vue&type=script&lang=ts&"
export * from "./ClientZoneUserVenueAuthorizations.vue?vue&type=script&lang=ts&"
import style0 from "./ClientZoneUserVenueAuthorizations.vue?vue&type=style&index=0&id=c11da638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11da638",
  null
  
)

export default component.exports